import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { OpsShell } from "~/components/shell/OpsShell";
import { CommandPaletteProvider } from "~/components/ops/command-palette";
import { PushBootstrap } from "~/components/push-bootstrap";
import { api } from "~/lib/api";
import { isOps } from "~/lib/auth";

export const Route = createFileRoute("/_authed/ops")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData({ queryKey: ["me"], queryFn: () => api.me() });
    if (!isOps(me)) throw redirect({ to: "/" });
  },
  component: OpsLayout,
});

function OpsLayout() {
  return (
    <CommandPaletteProvider>
      <OpsShell>
        <PushBootstrap askOnLoad />
        <Outlet />
      </OpsShell>
    </CommandPaletteProvider>
  );
}
